import { cn } from '../../lib/utils';
import './ui.css';

export function Input({ className, ...props }) {
  return <input className={cn('ui-input', className)} {...props} />;
}
